export const ImageStyle = 'rounded-full object-cover'

export const ImageSize = {
    small: 'w-12 h-12 rounded-full object-cover',
    medium: 'w-16 h-16 rounded-full object-cover',
    base: 'w-[80px] h-[80px] rounded-full object-cover',
    large: 'w-[91px] h-[91px] rounded-full object-cover',
}
